import c from "../../../resize-observer-polyfill/dist/ResizeObserver.es.mjs";
var n = /* @__PURE__ */ new Map();
function v(e) {
  e.forEach(function(t) {
    var r, o = t.target;
    (r = n.get(o)) === null || r === void 0 || r.forEach(function(a) {
      return a(o);
    });
  });
}
var s = new c(v);
process.env.NODE_ENV;
process.env.NODE_ENV;
function i(e, t) {
  n.has(e) || (n.set(e, /* @__PURE__ */ new Set()), s.observe(e)), n.get(e).add(t);
}
function u(e, t) {
  n.has(e) && (n.get(e).delete(t), n.get(e).size || (s.unobserve(e), n.delete(e)));
}
export {
  i as observe,
  u as unobserve
};
//# sourceMappingURL=observerUtil.mjs.map
